import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Lenis from "lenis";
import { Footer, MobileBottomCTA, Navbar } from "@/components/chrome";
import { Eva, Hero, Manifesto, Pain } from "@/sections/Part1";
import { Aree, Metodo, NonCorso } from "@/sections/Part2";
import { Chiara, PrimaDopo, Proverbi, Ruolo } from "@/sections/Part3";
import { ComeFunziona, Conversione, LavoroInsieme, NonPer, PerChi } from "@/sections/Part4";
import { CtaFinale, Faq, Finale, Firma } from "@/sections/Part5";
import { CookiePage, PrivacyPage, TerminiPage } from "@/pages/Legal";

const Landing = () => (
  <div className="bg-[#FDFBF7]" data-testid="landing-page">
    <Navbar />
    <main className="pb-20 lg:pb-0">
      <Hero />
      <Pain />
      <Manifesto />
      <Eva />
      <Metodo />
      <Aree />
      <NonCorso />
      <Chiara />
      <Ruolo />
      <PrimaDopo />
      <Proverbi />
      <PerChi />
      <Conversione />
      <NonPer />
      <ComeFunziona />
      <LavoroInsieme />
      <Faq />
      <Finale />
      <CtaFinale />
      <Firma />
    </main>
    <Footer />
    <MobileBottomCTA />
  </div>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/cookie-policy" element={<CookiePage />} />
          <Route path="/termini" element={<TerminiPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
